import { BoExternalSavingsFundsRequestDetails } from '@Common/types/bo_external/savings_funds_requests';
import { CoCardTopUpsStatus } from '@Common/types/funding/deposit';

import { KeysOfUnion } from '@sh4res/bo-common/utils/keys_of_union';

export const b2bSavingsFundsRequestsTranslations = {
  fields: {
    id: 'ID Appel de fonds',
    b2b_company_id: 'ID Entreprise',
    b2b_withdrawal_id: 'ID Retrait',
    company_name: 'Raison sociale',
    number_of_eligible_employees: "Nombre d'adhérent éligible",
    date: 'Date',
    total_gross_amount: 'Montant brut total',
    total_net_amount: 'Montnant net total à régler',
    total_contribution_amount: 'Montant total des contributions sociales Total',
    created_at: 'Créé à',
    updated_at: 'Mis à jour à',
    status: 'Statut',
    execution_error: "Détails de l'erreur",
    type: 'Type',
    payment_reference: 'Référence du paiement',
    due_date: "Date d'échéance",
    co_payment_status: 'Statut du paiement',
    campaign_id: 'ID Opération liée',
    campaign_type: 'Type de opération',
    currency: 'Devise',
    ts_user_total_nb_eligible: `Nombre d'employés éligibles`,
    ts_user_total_gross_amount: 'Montant brut (employés)',
    ts_user_total_contribution_amount: 'Montant de la contribution sociale de 9,7 % (employés)',
    ts_user_total_csg_tax_amount: 'Montant de la CSG de 9,2 % (employés)',
    ts_user_total_crds_tax_amount: 'Montant de la CRDS de 0,5 % (employés)',
    ts_user_total_net_amount: 'Montant net à payer (employés)',
    tns_user_total_nb_eligible: 'Nombre de travailleurs indépendants éligibles',
    tns_user_total_gross_amount: 'Montant brut (travailleurs indépendants)',
    tns_user_total_contribution_amount:
      'Montant de la contribution sociale de 9,7 % (travailleurs indépendants)',
    tns_user_total_csg_tax_amount: 'Montant de la CSG de 9,2 % (travailleurs indépendants)',
    tns_user_total_crds_tax_amount: 'Montant de la CRDS de 0,5 % (travailleurs indépendants)',
    tns_user_total_net_amount: 'Montant net à payer (travailleurs indépendants)',
    campaign_operation_summary: 'Récapitulatif des montants',
    fund_request_document: 'Bordereau de paiement',
    is_marked_as_completed: 'Marqué comme terminé',
    is_marked_as_paid: 'Marqué comme payé',
    is_marked_as_cancelled: 'Marqué comme annulé',
    is_sepa_direct_debit_retryable: 'Prélèvement SEPA relançable',
  } satisfies Record<
    KeysOfUnion<
      BoExternalSavingsFundsRequestDetails & {
        campaign_operation_summary: string;
        fund_request_document: string;
        execution_error: string;
        due_date: string;
      }
    >,
    string
  >,
  employees_breakdown: {
    title: 'Répartition des employés',
  },
  contractors_breakdown: {
    title: 'Répartition des travailleurs indépendants',
  },
  employees: {
    section_title: 'Répartition par salarié éligible',
    totals: {
      number_of_eligible_employees: 'Nombre de salariés éligibles',
      total_gross_amount: 'Montant brut total',
      total_contribution_amount: 'Montant des prélèvements sociaux (9,7 %)',
      total_csg_tax_amount: 'Montant de la CSG (9,2 %)',
      total_crds_tax_amount: 'Montant de la CRDS (0,5 %)',
      total_net_amount: 'Montant net total à payer',
    },
    fields: {
      employee_id: 'ID salarié',
      firstname: 'Prénom',
      lastname: 'Nom',
      identifier: 'Identifiant',
      registration_number: 'Matricule',
      social_status: 'Statut social',
      gross_amount: 'Montant brut',
      contribution_amount: 'Montant des prélèvements sociaux',
      csg_tax_amount: 'Montant de la CSG',
      crds_tax_amount: 'Montant de la CRDS',
      net_amount: 'Montant net',
    },
  },
  choices: {
    status: {
      check_employer_balance: "Vérifier le solde de l'employeur",
      promote_orders: 'Promouvoir les ordres',
      funds_request_paid: 'Payé',
      funds_request_completed: 'Complété',
      check_employer_balance_failed: "Échec de la vérification du solde de l'employeur",
      promote_orders_failed: 'Échec promotion des ordres',
      funds_request_paid_failed: 'Échec paiement',
      funds_request_completed_failed: 'Échec réalisation',
      finished: 'Fini',
      finished_failed: 'Échec finition',
      cancelled: 'Annulé',
      cancelled_failed: 'Échec annulation',
      pending: 'En attente',
    } satisfies Record<
      | Exclude<
          NonNullable<BoExternalSavingsFundsRequestDetails['status']>,
          'funds_request_pending'
        >
      | 'pending',
      string
    >,
    recon_status: {
      balanced: 'Équilibré',
      over_paid: 'Surpayé',
      under_paid: 'Sous-payé',
    },
    co_payment_status: {
      initiated: 'Initié',
      pending: 'En attente',
      captured: 'Capturé',
      rejected: 'Rejeté',
      settled: 'Réglé',
      authorization_declined: 'Autorisation refusée',
      shares_cancelled: 'Annulé',
      pending_declined: 'En attente refusé',
      card_verified: 'Carte vérifiée',
      card_verification_declined: 'Vérification de la carte refusée',
      returned: 'Retourné',
      refunded: 'Remboursé',
      partially_refunded: 'Partiellement remboursé',
    } satisfies Record<CoCardTopUpsStatus, string>,
    type: {
      b2b_management_fee: 'Frais de gestion',
      b2b_custody_fee: 'Frais de tenue de compte',
      matching_contribution: 'Abondement',
      campaign: 'Opération',
      ccb_withdrawal: 'Retrait CCB',
      capital_increase: 'Augmentation de capital',
    } satisfies Record<BoExternalSavingsFundsRequestDetails['type'], string>,
    treasury_color: {
      green: 'Équilibré',
      orange: 'Équilibré (en attente)',
      red: 'Déséquilibré',
    },
  },
  orders: {
    fields: {
      id: 'ID Ordre',
      total_gross_amount: 'Montant brut',
      user_currency_amount: 'Montant net',
      tax_amount: 'Montant des contributions sociales',
      matched_contribution_order_id: 'ID Ordre lié',
      entry_fee_amount: "Montant des frais d'entrée",
      entry_fee_pct: "% frais d'entrée",
      instrument_id: 'ID Instrument',
      isin: 'ISIN',
      status: 'Statut ordre',
    },
    section_title: 'Répartition par ordre éligibles',
    subtitle: "L'export inclut les investissements Libre et Piloté/Profilé.",
    export: {
      button: 'Tout exporter',
    },
  },
  payouts: {
    fields: {
      id: 'ID paiement',
      total_gross_amount: 'Montant brut',
      user_currency_amount: 'Montant net',
      tax_amount: 'Montant des contributions sociales',
      status: 'Statut paiement',
    },
    section_title: 'Versements immédiats',
  },
  fully_managed_plan_contributions: {
    fields: {
      id: 'ID abondement',
      total_gross_amount: 'Montant brut',
      user_currency_amount: 'Montant net',
      tax_amount: 'Montant des contributions sociales',
      status: 'Statut abondement',
    },
    section_title: 'Investissements dans plans pilotés/profilés',
  },
  payments: {
    button: 'Payer',
    title: 'Initier un paiement',
    step_payment: 'Paiement',
    step_confirmation: 'Confirmation',
    amount_paid: 'Montant payé',
    beneficiary_details: 'Détails du bénéficiaire',
    fields: {
      name: 'Nom du bénéficiaire',
      acc_iban: 'IBAN',
      acc_bic: 'BIC/SWIFT',
      reference: 'Référence du paiement',
    },
    confirmation_title: 'Confirmation',
    confirmation:
      'Je confirme avoir initié le paiement vers le bénéficiaire suivant et avoir ajouté la référence du paiement',
    use_beneficiary_details: 'Utiliser les informations du bénéficiaire ci-dessous',
    important_information_title: 'Informations importantes',
    important_information_body_1:
      "Effectuez un transfert à partir d'un compte à votre nom. Les virements provenant de comptes tiers seront rejetés.",
    important_information_body_2: 'Seuls les transferts en euros sont acceptés',
    important_information_body_3:
      'Les transferts arrivent généralement dans un délai de 1 à 2 jours ouvrables.',
    success: 'Action envoyée',
    failure: 'Erreur lors de l’envoi de l’action : %{error}',
    completed: 'Marquer comme terminé',
    mark_as_paid: 'Marquer comme payé',
    cant_show_bank_details:
      'Les informations du bénéficiaire ne sont pas disponibles, veuillez contacter votre administrateur',
  },
};
